// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
import "channels";

import JQuery from "jquery";
window.$ = window.JQuery = JQuery;

import "popper.js";
import "bootstrap";

require("./src/typing.js");
require("./src/datatable.js");
require("./src/autocomplete");
require("./nested-forms/addFields");
require("./nested-forms/removeFields");

Rails.start();
ActiveStorage.start();
